import { combineReducers } from 'redux'

// reducers
import cartForm from './cartForm'

const cartReducer = combineReducers({
  cartForm
})

export default cartReducer
